import { RootState } from "..";

export const getUploadStep = (state: RootState) =>
  state.DatasetReducer.uploadStep;

export const getIsUploadStarted = (state: RootState) =>
  state.DatasetReducer.isUploadStarted;
